// src/components/SecureDomainRoute.jsx
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { domainUUIDManager } from '../service/domainUUIDManager';

const SecureDomainRoute = ({ children, fallbackPath = "/Trade-Not-found" }) => {
  const { domainUUID } = useParams();
  const navigate = useNavigate();
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const validateDomainUUID = () => {
      setLoading(true);
      
      try {
        if (!domainUUID) {
          setIsValid(false);
          navigate(fallbackPath);
          return;
        }

        // Valider l'UUID
        const isValidUUID = domainUUIDManager.isValidDomainUUID(domainUUID);
        
        if (isValidUUID) {
          setIsValid(true);
        } else {
          console.warn(`Invalid domain UUID attempted: ${domainUUID}`);
          setIsValid(false);
          navigate(fallbackPath);
        }
      } catch (error) {
        console.error('Error validating domain UUID:', error);
        setIsValid(false);
        navigate(fallbackPath);
      } finally {
        setLoading(false);
      }
    };

    validateDomainUUID();
  }, [domainUUID, navigate, fallbackPath]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-50">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Validation du domaine...</span>
        </div>
      </div>
    );
  }

  if (!isValid) {
    return null; // La redirection est gérée dans useEffect
  }

  return children;
};

export default SecureDomainRoute;